import React from 'react';
import Icon from 'apps/new-web/views/components/icon';
import benefits from './benefit-list';
import { blueGray54 } from 'apps/new-web/views/themes/colors';

const FusionBenefitsDesktop = () => {
  return (
    <div className="benefits">
      { benefits.map( (benefit, idx) => (
        <div className="item" key={ `benefit-${benefit.icon.name}` }>
          <span className="icon">
            <Icon icon={ benefit.icon } color={ blueGray54 } size={ 20 } />
          </span>
          <h3>{ benefit.title }</h3>
          <p>{ benefit.content }</p>
        </div>
      ))
      }
    </div>
  );
};

export default FusionBenefitsDesktop;
